import script from "./RouterSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterSidebar.vue?vue&type=script&setup=true&lang=js"

import "./RouterSidebar.vue?vue&type=style&index=0&id=a4cac5d8&scoped=true&lang=css"

import exportComponent from "/Users/wangcaijuan/var/www/oa-show/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4cac5d8"]])

export default __exports__